var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.$t("wp.authenticating")))]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "d-flex justify-content-center align-items-center",
        staticStyle: { "font-size": "22px" },
      },
      [
        _c("div", [
          _c("div", [_vm._v(_vm._s(_vm.$t("wp.activationTitle")))]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [_vm._v(_vm._s(_vm.$t("wp.wpIntegrationInstruction1")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("wp.wpIntegrationInstruction2")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("wp.wpIntegrationInstruction3")))]),
          ]),
        ]),
        _vm._v(" "),
        _vm.channelId
          ? _c("div", [
              _vm.isChannelQRCodeGenerating()
                ? _c(
                    "div",
                    {
                      staticClass:
                        "p-3 d-flex flex-column justify-content-center align-items-center",
                    },
                    [
                      _c("span", { staticClass: "text-info" }, [
                        _vm._v(_vm._s(_vm.$t("wp.qrGeneratingWait"))),
                      ]),
                      _vm._v(" "),
                      _c("md-progress-spinner", {
                        staticClass: "md-accent text-danger",
                        attrs: {
                          "md-diameter": 20,
                          "md-mode": "indeterminate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isChannelAuthenticating()
                ? _c(
                    "div",
                    {
                      staticClass:
                        "p-3 d-flex flex-column justify-content-center align-items-center",
                    },
                    [
                      _c("span", { staticClass: "text-info" }, [
                        _vm._v(_vm._s(_vm.$t("wp.authenticatingWait"))),
                      ]),
                      _vm._v(" "),
                      _c("md-progress-spinner", {
                        staticClass: "md-accent text-danger",
                        attrs: {
                          "md-diameter": 20,
                          "md-mode": "indeterminate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isChannelQRCodeGenerated()
                ? _c("div", [
                    _c("img", {
                      key: _vm.imageRefreshKey,
                      staticClass: "qr-code",
                      attrs: {
                        src: _vm.getQRAddress(),
                        alt: _vm.$t("wp.qrCodeImageAlt"),
                      },
                    }),
                  ])
                : _vm._e(),
            ])
          : _c("div", [
              _vm.isQRCodeGenerating
                ? _c(
                    "div",
                    {
                      staticClass:
                        "p-3 d-flex flex-column justify-content-center align-items-center",
                    },
                    [
                      _c("span", { staticClass: "text-info" }, [
                        _vm._v(_vm._s(_vm.$t("wp.qrGeneratingWait"))),
                      ]),
                      _vm._v(" "),
                      _c("md-progress-spinner", {
                        staticClass: "md-accent text-danger",
                        attrs: {
                          "md-diameter": 20,
                          "md-mode": "indeterminate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isAuthenticating
                ? _c(
                    "div",
                    {
                      staticClass:
                        "p-3 d-flex flex-column justify-content-center align-items-center",
                    },
                    [
                      _c("span", { staticClass: "text-info" }, [
                        _vm._v(_vm._s(_vm.$t("wp.authenticatingWait"))),
                      ]),
                      _vm._v(" "),
                      _c("md-progress-spinner", {
                        staticClass: "md-accent text-danger",
                        attrs: {
                          "md-diameter": 20,
                          "md-mode": "indeterminate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isQRCodeGenerated
                ? _c("div", [
                    _c("img", {
                      key: _vm.imageRefreshKey,
                      staticClass: "qr-code",
                      attrs: {
                        src: _vm.getQRAddress(),
                        alt: _vm.$t("wp.qrCodeImageAlt"),
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
      ]
    ),
    _vm._v(" "),
    _vm.continueToWait
      ? _c(
          "div",
          {
            staticClass:
              "p-3 d-flex flex-column justify-content-center align-items-center",
          },
          [
            _c("span", { staticClass: "text-info" }, [
              _vm._v(_vm._s(_vm.$t("wp.pleaseContinueToWaitUntilCompleted"))),
            ]),
            _vm._v(" "),
            _c("md-progress-spinner", {
              attrs: {
                "md-diameter": 20,
                "md-stroke": 3,
                "md-mode": "indeterminate",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }